import styled from 'react-emotion'

import { spacers } from '../theme'

const Hero = styled('div')`
	padding: ${spacers['8']} 0;
	text-align: center;
`

export default Hero
